
import axios from "axios";
import { decodeJWT } from "../utils/jwt";
import { getToken } from "./axios";

// Constants
const STORAGE_KEYS = {
  USER_AUTH_ID: "user_auth_id",
  PROJECT_ID: "project_id",
  USER_IS_READONLY: "user_is_readonly"
};

// Helper function to get user auth ID from token or localStorage
const getUserAuthId = async () => {
  let userAuthId = localStorage.getItem(STORAGE_KEYS.USER_AUTH_ID);
  
  if (!userAuthId) {
    try {
      const token = await getToken();
      if (!token) return null;
      
      const decodedToken = decodeJWT(token);
      userAuthId = decodedToken?.id;
      
      if (userAuthId) {
        localStorage.setItem(STORAGE_KEYS.USER_AUTH_ID, userAuthId);
      }
    } catch (error) {
      console.error("Error extracting user details from token:", error);
      return null;
    }
  }
  
  return userAuthId;
};

// Main function to check and update read-only status
export const checkAndUpdateReadOnlyStatus = async () => {
  try {
    const userAuthId = await getUserAuthId();
    if (!userAuthId) {
      localStorage.setItem(STORAGE_KEYS.USER_IS_READONLY, "false");
      return false;
    }

    const apiUrl = process.env.REACT_APP_API;
    const token = await getToken();
    const projectId = localStorage.getItem(STORAGE_KEYS.PROJECT_ID);

    const response = await axios({
      method: 'get',
      url: `${apiUrl}/api/project/get_users`,
      params: { user_auth_id: userAuthId },
      headers: {
        "X-Device": "web",
        "Authorization": token ? `Bearer ${token}` : "",
        "project_id": projectId || ""
      }
    });

    const isReadOnly = response.data[0] && 
      (response.data[0].role_auth === 0 || response.data[0].role_auth === "0");
    
    localStorage.setItem(STORAGE_KEYS.USER_IS_READONLY, isReadOnly ? "true" : "false");
    return isReadOnly;
    
  } catch (error) {
    console.error("Error checking read-only status:", error);
    localStorage.setItem(STORAGE_KEYS.USER_IS_READONLY, "false");
    return false;
  }
};

// Synchronous function to get current readonly status from localStorage
export const isReadOnly = () => {
  return localStorage.getItem(STORAGE_KEYS.USER_IS_READONLY) === "true";
};

// Function to refresh readonly status (call when project changes)
export const refreshReadOnlyStatus = async () => {
  try {
    return await checkAndUpdateReadOnlyStatus();
  } catch (error) {
    console.error("Error refreshing readonly status:", error);
    localStorage.setItem(STORAGE_KEYS.USER_IS_READONLY, "false");
    return false;
  }
};

// Initialize status on module load
checkAndUpdateReadOnlyStatus();

// Export legacy function name for backward compatibility (optional)
export const checkReadOnlyStatus = checkAndUpdateReadOnlyStatus;
export const is_readonly = isReadOnly;